export default __webpack_public_path__ + "static/media/login-illustration.04ef5972.svg";